import { LoaderFunctionArgs } from "react-router";
import { useLoaderData } from "react-router";
import { WORDPRESS_API_URL, WORDPRESS_API_PATH } from "~/lib/util";

export async function loader({ context }: LoaderFunctionArgs) {

	const res = await fetch(WORDPRESS_API_URL + WORDPRESS_API_PATH + 'update?per_page=100&_embed=author');
	const updates = await res.json();

	console.log(updates[0])

	return ({
		updates
	})
}

export default function UpdatesIndexPage() {
	const { updates } = useLoaderData<typeof loader>();

	return <>
		<section className="lg:container mx-4 lg:mx-auto">
			<h1 className="fluid-60 text-center dark:text-primary-100">Latest updates from DefiPlaza</h1>

			<div className="relative grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-16 p-4 md:p-20 pt-4 bg-primary-700 rounded-lg md:rounded-3xl overflow-hidden">

				{updates.map(update => (
					<div key={update.id}className="z-10 py-16 px-8 flex flex-col justify-between rounded-lg bg-white dark:bg-primary-800 content-between">
						<div>
							<h3 className="text-2xl font-bold"><a href={ `/update/${update.slug}` }>{update.title.rendered}</a></h3>
							{/* <p className="mt-4 text-base text-primary-500 dark:text-primary-100">{update.text}</p> */}
							<p className="mt-4 text-base line-clamp-3">{update.yoast_head_json.og_description}</p>
						</div>
						<a href={ `/update/${update.slug}` } className="mt-16 btn-primary rounded-full w-min">
							<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-right" className="w-4 h-4" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
								<path fill="currentcolor" d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path>
							</svg>
						</a>
					</div>
				))}

			</div>
		</section>
	</>
}